import { useEffect } from "react";
import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.GOOGLE_SITE_ID;
const SITE_URL = process.env.SITE_URL || "";

let isGAInitialized = false;

const GoogleAnalytics = ({ page, title }) => {
  useEffect(() => {
    if (!isGAInitialized && MEASUREMENT_ID) {
      ReactGA.initialize(MEASUREMENT_ID);
      isGAInitialized = true;
    }

    const fullUrl = `${SITE_URL}${page || window.location.pathname}`;

    ReactGA.send({
      hitType: "pageview",
      page: fullUrl,
      title: title || document.title,
    });
  }, [page, title]);

  return null;
};

// Optional: Manual GA event logging
export const logEvent = ({ category, action, label, value }) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

export default GoogleAnalytics;
